import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('UnifiedProfile').create(({ theme }) => ({
  root: {
    position: 'relative',
    width: '100%',

    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    alignItems: 'center',
    paddingBottom: 'calc(10vh + 40px)',
  },
  header: {
    position: 'relative',
    width: '100%',
    minHeight: '220px',
  },

  bgImg: {
    width: '100%',
  },

  logoImg: {
    position: 'absolute',
    top: '20%',
    width: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },

  content: {
    width: '100%',
    overflowX: 'scroll',
  },
  title: {
    color: theme.colors.text.primary,
    fontSize: theme.sizes.texts.fontSize.l,
    fontWeight: 500,
    lineHeight: theme.sizes.texts.fontSize.l,

    paddingTop: theme.sizes.texts.fontSize.s,
    textAlign: 'left',
    alignSelf: 'start',
  },

  stats: {
    gap: '12px',
    padding: '0px 16px',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
  },

  privacy: {
    padding: '0px 16px',
    paddingTop: theme.sizes.texts.fontSize.s,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    h1: {
      margin: 0,
      padding: 0,

      color: theme.colors.text.primary,
      fontSize: theme.sizes.texts.fontSize.l,
      fontWeight: 500,
      lineHeight: theme.sizes.texts.fontSize.l,

      textAlign: 'left',
      alignSelf: 'center',
    },
  },
}))
